import { Component, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterLink } from '@angular/router';
import { NavigationService } from '../../Services/navigation.service';
import { SmoothScrollOptions, SmoothScrollService } from '../../Services/smooth-scroll.service';

export interface NavItem {
  title: string;
  link: string;
  scrollOptions?: SmoothScrollOptions;
}

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  // Injected services
  navigationService = inject(NavigationService);
  smoothScrollService = inject(SmoothScrollService);
  private readonly platformId = inject(PLATFORM_ID);
  readonly isBrowser: boolean = isPlatformBrowser(this.platformId);

  // Footer navigation links with smooth scroll configuration
  quickLinks: NavItem[] = [
    { title: 'Home', link: '#hero', scrollOptions: { duration: 700, offset: 80, block: 'start' } },
    { title: 'About Us', link: '#about-us', scrollOptions: { duration: 700, offset: 80, block: 'start' } },
    { title: 'Services', link: '#our-services', scrollOptions: { duration: 700, offset: 80, block: 'start' } },
    { title: 'Projects', link: '#projects', scrollOptions: { duration: 700, offset: 80, block: 'start' } },
  ];

  resourcesLinks: NavItem[] = [
    // { title: 'Testimonials', link: '#testimonials', scrollOptions: { duration: 700, offset: 80, block: 'start' } },
    { title: 'Contact', link: '#contact-us', scrollOptions: { duration: 700, offset: 80, block: 'start' } },
  ];

  socialLinks: any[] = [
  /*  {
      title: 'LinkedIn',
      icon: 'linkedin',
      link: 'https://linkedin.com',
    },
    {
      title: 'Twitter',
      icon: 'twitter',
      link: 'https://twitter.com',
    },
    {
      title: 'Facebook',
      icon: 'facebook',
      link: 'https://facebook.com',
    },*/
    { title: 'Testimonials', link: '#testimonials', scrollOptions: { duration: 700, offset: 80, block: 'start' } },
  ];

  currentYear = new Date().getFullYear();

  /**
   * Handles anchor link clicks with smooth scroll animation
   * Prevents default browser jump behavior and uses NavigationService for smooth scrolling
   */
  async onAnchorItemClick(event: MouseEvent, link: string, opts?: SmoothScrollOptions): Promise<void> {
    event.preventDefault();
    // Extract element ID from link (remove '#' prefix)
    const id = link.startsWith('#') ? link.slice(1) : link;
    // Navigate to the element with smooth scroll animation
    await this.navigationService.navigateTo('/', {
      elementId: id,
      offset: opts?.offset ?? 80,
      duration: opts?.duration ?? 700,
      block: opts?.block ?? 'start',
      easing: opts?.easing,
    });
  }

  /**
   * Smoothly scrolls to the top of the page using SmoothScrollService
   */
  async scrollToTop(): Promise<void> {
    if (!this.isBrowser) return;
    await this.smoothScrollService.scrollTo('body', {
      duration: 700,
      offset: 0,
      block: 'start',
    });
  }
}
